module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"students_join_class_with_code","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"classCode":{"type":"string"}},"required":["user","classCode"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/students_join_class_with_code.json
// module id = 589
// module chunks = 97